import { BaseViewModel } from "./base.viewmodel";

export class HomeViewModel implements BaseViewModel {
    PageTitle: string = 'Home';
    // tabLocation: number = AboutTabs.tab1;
}